<!-- 接口测试Demo -->
<template>
<div class="site-content">
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col col-per-70">
        <button @click="sendPostRequest">发送请求1</button>==>>{{msg}}
        <button @click="sendPostRequest2">发送请求2</button>==>>{{msg}}
        <infoPageList-02 :showTitle="true" :showOrder="false" :showMore="false" :infoPage="infoPage" :infoBlock="pageInfoBlock" title="资讯列表" label="INFORMARION" :tabList="tabList" tabClass="list-tab-ul-1" count="20" v-on:queryPage="sendPostRequest" v-on:clickTab="chooseTab"/>
      </div>
      <div class="content-col col-per-30">
        <infoList title="推荐政策" :showTitle="true" :infoBlock="titleInfoBlock01" :infoPage="infoPage1" v-on:queryPage="sendPostRequest1" label="INFORMARION" titleLength="18" count="8"/>
        <infoList title="推荐项目" :showTitle="true" :infoBlock="titleInfoBlock01" :infoPage="infoPage2" v-on:queryPage="sendPostRequest2" label="INFORMARION" titleLength="18" count="8"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoPageList02 from '../block/InfoPageList02'
import JghqInfo2 from '../module/JghqInfo2'
import JghqInfo from '../module/JghqInfo'
import InfoList from '../block/InfoList'
import TitleInfoBlock01 from '../block/TitleInfoBlock01'

import axios from 'axios'
export default {
  name: 'ZZDemo01',
  components: {
    'infoPageList-02': InfoPageList02,
    'infoList': InfoList,
  },
  data() {
    return {
      msg: '测试结果',
      pageInfoBlock:JghqInfo,
      titleInfoBlock01:TitleInfoBlock01,
      tabList:[{title:"招商政策"},{title:"招商项目"}],
      infoPage:{},
      infoPage1:{},
      infoPage2:{},
    }
  },
  methods:{
    chooseTab:function(tabIndex){
      //this.selectedItem=clickedItem.title
      console.log("------回调成功"+tabIndex);
      if(tabIndex==0){
        this.pageInfoBlock=JghqInfo;
      }else{
        this.pageInfoBlock=JghqInfo2;
      }
      this.sendPostRequest({pageSize:4,page:1,tabId:tabIndex});
    },
    sendPostRequestTest(){
          let that=this;
          console.log('开始请求12：');
          axios({
            method:'get',
            url:'/api/browserClient/billSearch/getInfo.action?accountNo=073069600&verCode=5hvm'
          }).then(function(resp){
            console.log(resp.data);
            that.msg=resp.data.msg
          }).catch(
            resp=>{
              that.msg='请求失败：'+resp.status+','+resp.statusText;

              console.log('请求失败：'+resp.status+','+resp.statusText);
            }
          );
      },
    sendPostRequest(params){
          let that=this;
          let result={page:params};
          console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
          that.$dataApi.articleList(params).then(res =>{
          that.msg=res.msg;
          //that.tabList=res.data.list;
          //that.tabList=[];
          result.list= res.data.list;
          result.page.total=res.data.total;
          that.infoPage=result;

          console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });

    },
    sendPostRequest1(params){
      params.type='policy_library';
      let that=this;
      let result={page:params};
      console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
      that.$dataApi.articleList(params).then(res =>{
        that.msg=res.msg;
        //that.tabList=res.data.list;
        //that.tabList=[];
        result.list= res.data.list;
        result.page.total=res.data.total;
        that.infoPage1=result;

        console.log('结束请求Vue-axios：'+JSON.stringify(result))
      });

    },
    sendPostRequest2(params){
      params.queryYear='2021';
      params.queryMonth='4';
      let that=this;
      let result={page:params};

      console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
      that.$dataApi.fastNewsLists(params).then(res =>{
        that.msg=res.msg;
        //that.tabList=res.data.list;
        //that.tabList=[];
        result.list= res.data.list;
        result.page.total=res.data.total;
        that.infoPage2=result;

        console.log('结束请求Vue-axios：'+JSON.stringify(result))
      });
    },
  },
  created:function(){
    let params={page:1,pageSize:7,tabId:1};
    this.sendPostRequest(params);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow:3;
}

.col-per-30 {
  flex-grow:1;
}
</style>



// WEBPACK FOOTER //
// src/components/page/ZZDemo01.vue